import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const styleShared = StyleSheet.create({
  wrapper: {
    backgroundColor: neutrals.white,
    flex: 1,
  },
  headerLeft: { flex: 1, justifyContent: 'center' },
  headerCenter: { flex: 2, justifyContent: 'center', alignItems: 'center' },
  headetButton: { flexDirection: 'row', alignItems: 'center', gap: 8 },
  header: {
    padding: 24,
    width: '100%',
    flexDirection: 'row',
  },
  container: {
    borderRadius: 20,
    borderWidth: 3,
    borderStyle: 'dashed',
    borderColor: brand.main.variations['lighterWater-2'],
    backgroundColor: neutrals.coldGrays.ice,
    justifyContent: 'center',
  },
  containerRight: {
    borderRadius: 20,
    backgroundColor: neutrals.coldGrays.ice,
    alignItems: 'center',
  },
  backButtonText: {
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 18,
    color: brand.main.water,
  },
  sideWrapper: { flex: 1 },
  sideWrapperContent: { padding: 32, gap: 32, alignItems: 'center' },
  sideWrapperTable: {
    padding: 16,
  },
  loadingContentDetails: {
    width: 300,
    alignItems: 'center',
    alignSelf: 'center',
    gap: 16,
  },
  loadingContentText: {
    color: neutrals.neutralGrays.cement,
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 31,
    textAlign: 'center',
  },
  backButton: { flexDirection: 'row', gap: 8, alignItems: 'center' },
});

export const stylesDesktop = StyleSheet.create({
  ...styleShared,
  headerRight: { flex: 1, justifyContent: 'center', alignItems: 'flex-end' },
  body: {
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: 32,
    paddingBottom: 32,
  },
  bodyInner: {},
});

export const stylesMobile = StyleSheet.create({
  ...styleShared,
  headerRight: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 16,
  },
  body: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  bodyInner: {
    flex: 1,
    width: '90%',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
    marginVertical: 24,
    backgroundColor: neutrals.coldGrays.ice,
  },
});
